import React from 'react';
import { cn } from '../../utils/cn';

export const textareaFieldClassName =
  'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50';

const Textarea = React.forwardRef(({ className, ...props }, ref) => (
  <textarea ref={ref} className={cn(textareaFieldClassName, className)} {...props} />
));

Textarea.displayName = 'Textarea';

export default Textarea;
